export enum TagTypes {
  Sites = "Sites",
  SiteMap = "SiteMap",
  Audits = "Audits",
  YardList = "YardList",
  YardConfig = "YardConfig",
  YardMap = "YardMap",
  YardVisits = "YardVisits",
  YardAlerts = "YardAlerts",
  YardJobs = "YardJobs",
  YardMetrics = "YardMetrics",
  YardMoves = "YardMoves",
  GateEvents = "GateEvents",
  DriverVisitEvents = "DriverVisitEvents",
  YardDomainEvents = "YardDomainEvents",
  GateSensorEvents = "GateSensorEvents",
  EquipmentOwners = "EquipmentOwners",
  RyteGoals = "RyteGoals",
  RyteAppointments = "RyteAppointments",
  RyteEvents = "RyteEvents",
  YardGraph = "YardGraph",
}

export const TAG_TYPES = Object.values(TagTypes);
